import React from "react";

const Section9Warranties = () => (
  <>
    <h2>9. Warranties and Disclaimers</h2>
    <p>
    THE SERVICE IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
    </p>

    <p>
    COMPAREDLY LTD. DISCLAIMS ANY WARRANTIES REGARDING THE ACCURACY, RELIABILITY, AND COMPLETENESS OF ANY ANALYTICS DATA OBTAINED FROM THIRD-PARTY SOCIAL MEDIA PLATFORMS THROUGH THE SERVICE. THE SERVICE MAY BE SUBJECT TO LIMITATIONS, DELAYS, AND OTHER PROBLEMS INHERENT IN THE USE OF THE INTERNET AND ELECTRONIC COMMUNICATIONS. COMPAREDLY LTD. DOES NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED OR ERROR-FREE.
    </p>

  </>
);

export default Section9Warranties;
